<template>
	<h1 class="ui-title title"><slot/></h1>
</template>

<script>
export default {
	props: {

	}
};
</script>

<style lang="scss">
.ui-title {
	margin-bottom: 0 !important;
	font-size: 24px !important;
}
</style>
